// 1. React
import { memo } from "react";

// 2. Helpers
import { useTranslate } from "helpers";

// 3. Types
import { InvoiceConnectionProps } from "./types";

// 4. Form hooks
import { useHandleDropdownChange } from "services/forms/hooks";

// 5. UI Components
import ContactDropdown from "ui/components/Dropdown/ContactDropdown/ContactDropdown";
import VehicleDropdown from "ui/components/Dropdown/VehicleDropdown/VehicleDropdown";


const InvoiceConnection: React.FC<InvoiceConnectionProps> = (props) => {
    const { formValues, setFormValues } = props;

    const { t } = useTranslate();

    const handleDropdownChange = useHandleDropdownChange(
        setFormValues,
        formValues
    );

    return (
        <div className="flex flex-col gap-3">
            <div className="flex gap-4">
                <div className="flex-1">
                    <VehicleDropdown
                        placeholder={t("admin.fleet.vehicle.invoice.add.vehicle.placeholder")}
                        label={t("admin.fleet.vehicle.invoice.add.vehicle")}
                        name="vehicleId"
                        value={formValues.vehicleId}
                        onChange={handleDropdownChange}
                        disabled
                    />
                </div>
                <div className="flex-1">
                    <ContactDropdown
                        placeholder={t("admin.fleet.vehicle.invoice.add.contact.client.placeholder")}
                        label={t("admin.fleet.vehicle.invoice.add.contact.client")}
                        name="contactClientId"
                        value={formValues.contactClientId}
                        onChange={handleDropdownChange}
                        disabled
                    />
                </div>
            </div>
        </div>
    );
};

export default memo(InvoiceConnection);
